<template>
  <g
    id="Rear_Brake_Light"
    v-on:click="changeSeverity('rearBrakeLight')"
    :class="severityClass"
  >
    <path
      class="cls-526"
      d="M49.75,274h25.1c.3,0,.54,.24,.54,.54v12.4c0,.3-.24,.54-.54,.54h-25.1c-1.65,0-3-1.34-3-3v-7.47c0-1.65,1.34-3,3-3Z"
      transform="translate(-219.67 341.8) rotate(-90)"
    />
    <g>
      <circle
        class="cls-934"
        cx="60.95"
        cy="277.14"
        r="7.48"
        transform="translate(-68.17 24.46) rotate(-14.66)"
      />
      <circle
        class="cls-294"
        cx="60.95"
        cy="277.14"
        r="7.33"
        transform="translate(-68.13 24.43) rotate(-14.65)"
      />
      <circle
        class="cls-321"
        cx="60.95"
        cy="277.14"
        r="7.17"
        transform="translate(-68.07 24.4) rotate(-14.64)"
      />
      <circle
        class="cls-333"
        cx="60.95"
        cy="277.14"
        r="7.01"
        transform="translate(-68 24.37) rotate(-14.62)"
      />
      <circle
        class="cls-223"
        cx="60.95"
        cy="277.14"
        r="6.85"
        transform="translate(-67.89 24.31) rotate(-14.6)"
      />
      <circle
        class="cls-341"
        cx="60.95"
        cy="277.14"
        r="6.7"
        transform="translate(-67.74 24.24) rotate(-14.57)"
      />
      <circle
        class="cls-385"
        cx="60.95"
        cy="277.14"
        r="6.54"
        transform="translate(-67.48 24.1) rotate(-14.51)"
      />
      <circle class="cls-365" cx="60.95" cy="277.14" r="6.38" />
      <circle class="cls-380" cx="60.95" cy="277.14" r="6.22" />
      <circle class="cls-44" cx="60.95" cy="277.14" r="6.07" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
